<template>
  <a-modal
    title="电子围栏"
    style="top: 20px"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :footer="false"
    :maskClosable="false"
  >
    <div id="container3"></div>
    <a-row :gutter="24" style="height: 30px">
      <a-col :span="16"></a-col>
      <a-col :span="8" style="margin-top: 11px">
        <span style="display: flex; justify-content: center">
          <a-button :disabled="!editAreaEnable" type="primary" @click="rectangleEditor.open()">开始编辑</a-button>
          <a-button :disabled="!editAreaEnable" style="margin-left: 35px" @click="rectangleEditor.close()"
            >结束编辑</a-button
          >
        </span>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import AMap from 'AMap'
import { addAreaPoint } from '@/api/master/MasterList'
import { checkPermission } from '@/utils/permissions'

export default {
  name: 'Tomap',
  data() {
    return {
      rectangleEditor: null,
      visible: false,
      confirmLoading: false,
      editAreaEnable: checkPermission('master:list:area:edit')
    }
  },
  mounted() {
    // this.loadmap() // 加载地图和相关组件
  },
  methods: {
    add(data, code) {
      this.visible = true
      this.$nextTick(() => {
        this.loadmap(data, code)
      })
    },
    loadmap(data, code) {
      const that = this
      var southWest, northEast, lat, lon
      console.log(data.geometry.coordinates[0].length)
      if (data.geometry.coordinates[0].length < 4) {
        lat = data.geometry.coordinates[0][0]
        lon = data.geometry.coordinates[0][1]
        lon = data.geometry.coordinates[0][1]
        southWest = new AMap.LngLat(lon, lat)
        northEast = new AMap.LngLat(lon + 0.002, lat + 0.002)
        console.log(lat, lon, '两组数据')
      } else {
        lat = data.geometry.coordinates[0][0][1]
        lon = data.geometry.coordinates[0][0][0]
        console.log(lat, lon, '四组数据')
        southWest = new AMap.LngLat(data.geometry.coordinates[0][0][0], data.geometry.coordinates[0][0][1])
        northEast = new AMap.LngLat(data.geometry.coordinates[0][2][0], data.geometry.coordinates[0][2][1])
      }
      var map = new AMap.Map('container3', {
        center: [lon, lat],
        zoom: 13
      })
      var bounds = new AMap.Bounds(southWest, northEast)

      var rectangle = new AMap.Rectangle({
        bounds: bounds,
        strokeColor: 'red',
        strokeWeight: 6,
        strokeOpacity: 0.5,
        strokeDasharray: [30, 10],
        // strokeStyle还支持 solid
        strokeStyle: 'dashed',
        fillColor: 'blue',
        fillOpacity: 0.5,
        cursor: 'pointer',
        zIndex: 50
      })

      rectangle.setMap(map)
      // 缩放地图到合适的视野级别
      map.setFitView([rectangle])

      this.rectangleEditor = new AMap.RectangleEditor(map, rectangle)

      this.rectangleEditor.on('adjust', function(event) {
        // console.log(event,'开始')
      })
      this.rectangleEditor.on('end', function(event) {
        var arr = new Array()
        for (let i = 0; i < event.target.Ce.path.length; i++) {
          arr[i] = event.target.Ce.path[i].lng + ' ' + event.target.Ce.path[i].lat
          // arr.push({
          //   lat:event.target.De.path[i].lat,
          //   lng:event.target.De.path[i].lng,
          // })
        }
        arr[4] = arr[0]
        // console.log(arr)
        addAreaPoint({
          userId: code,
          polygongeo: arr
        }).then(res => {
          console.log(res)
          if (res.code == 0) {
            that.$message.success('保存成功')
            that.visible = false
          } else {
            that.$message.error(res.data)
          }
        })
        // console.log(event.target.Ce.path, '结束')
        // event.target 即为编辑后的矩形对象
      })
    }
  }
}
</script>

<style scoped>
#container3 {
  width: 760px;
  height: 500px;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 4px 16px;
}
</style>
